"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactNativeWeb = require("react-native-web");

var _AaChips = require("./AaChips.model");

var _StyleSheet = _interopRequireDefault(require("../../PlatformStyleSheet/StyleSheet"));

var _AaIcon = _interopRequireDefault(require("../airasia-icon-component/AaIcon.component"));

//use this once you move it to component library
var AaChips = function AaChips(props) {
  var controls = props.controls || null;
  var config = controls && controls.config || {}; //onPress

  var customStyle = {};

  if (controls && controls.style) {
    customStyle = _StyleSheet["default"].create({
      custom: controls.style
    });
  }

  var styling = _StyleSheet["default"].flatten([defaultStyles.chipContainer, customStyle.custom]);

  var _props$data = props.data,
      text = _props$data.text,
      icon = _props$data.icon;
  return /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.TouchableOpacity, {
    style: defaultStyles.chipContainer,
    onPress: config.onChipPress
  }, icon ? /*#__PURE__*/_react["default"].createElement(_AaIcon["default"], {
    controls: {
      iconName: icon,
      iconStyle: {
        marginLeft: 0,
        marginRight: 5
      }
    }
  }) : null, /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.Text, {
    style: defaultStyles.chipLabel
  }, text));
};

var defaultStyles = _StyleSheet["default"].create({
  chipContainer: {
    flexDirection: 'row',
    flexWrap: 'nowrap',
    backgroundColor: '#FFFFFF',
    borderWidth: 1,
    borderColor: '#D9DBE0',
    borderRadius: 15,
    paddingVertical: 15,
    paddingHorizontal: 8,
    alignItems: 'center',
    margin: 5,
    height: 20
  },
  chipLabel: {
    fontSize: 12,
    color: "#5c5f63",
    width: 'auto',
    height: 14
  }
});

var _default = AaChips;
exports["default"] = _default;